import axios from 'axios'

import { API_URI } from './config'
import LocalStorageService from './localStorageService'

axios.defaults.withCredentials = true

const axiosInstance = axios.create({
  baseURL: API_URI,
})

// Add a request interceptor
axiosInstance.interceptors.request.use(
  config => {
    // refreshToken is a silent background call — showing the full-screen
    // loading overlay for it makes the page look like it reloads on a timer
    if (!config.url?.includes('refreshToken')) {
      document.body.classList.add('loading-indicator')
    }
    const token = LocalStorageService.getAuthToken()
    config.headers['Content-Type'] = 'application/json';
    config.headers['Origin-Type'] = 'admin-panel';
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },

  error => {
    document.body.classList.remove('loading-indicator')
    Promise.reject(error)
  }
)

function forceLogout() {
  LocalStorageService.clearStorage()
  window.dispatchEvent(new Event('auth:expired'))
}

//Add a response interceptor
axiosInstance.interceptors.response.use(
  response => {
    document.body.classList.remove('loading-indicator')
    if (response?.data?.results?.data) {
      return response.data.results.data
    } else if (response?.data?.error) {
      return Promise.reject(response.data.message)
    } else if (response?.data?.results?.docs) {
      return response.data.results
    }
    return response.data
  },
  function (error) {
    document.body.classList.remove('loading-indicator')
    const originalRequest = error.config
    const status = error.response?.status
    const isRefreshCall = originalRequest?.url?.includes('refreshToken')


    if (status === 401 && !isRefreshCall && !originalRequest._retry) {
      originalRequest._retry = true

      return axiosInstance
        .post('/refreshToken')
        .then(authInfo => {
          LocalStorageService.setAuthInfo(authInfo)
          const newToken = LocalStorageService.getAuthToken()
          axiosInstance.defaults.headers.common['Authorization'] = 'Bearer ' + newToken
          originalRequest.headers['Authorization'] = 'Bearer ' + newToken
          return axiosInstance(originalRequest)
        })
        .catch(refreshError => {
          // We had a request fail auth, and renewing the session also failed -> truly expired.
          forceLogout()
          return Promise.reject(refreshError)
        })
    }

    return Promise.reject(error)
  }
)

export default axiosInstance
